import { render, staticRenderFns } from "./commentTask.vue?vue&type=template&id=57bb5bb8&scoped=true&"
import script from "./commentTask.vue?vue&type=script&lang=js&"
export * from "./commentTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb5bb8",
  null
  
)

export default component.exports